import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup } from 'barnyard/components';
import CategorySelect from '~/app/corporate/core/containers/CategorySelect';


const InlineCategorySelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;


  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={CategorySelect}
      useNative={false}
      mode='multiple'
      showSearch={true}
      parentOnly={true}
      placeholder='Select categories...'
      {...other}
    />
  );
};

InlineCategorySelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineCategorySelect.defaultProps = {
  label: 'Category',
  description: 'Category to be included'
};

export default memo(InlineCategorySelect);
